import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { closeWarrants } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';
import { handleError } from 'reducers/ErrorReducer';
import WarrantCard from 'components/WarrantCard';
import { getPersonWarrant } from 'reducers/WarrantReducer';
import CircularProgress from '@material-ui/core/CircularProgress';

// const useStyles = makeStyles((theme) => ({
//   loading: {
//     width: 500,
//     height: 400,
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     flexDirection: 'column',
//   },
// }));

function WarrantDialog(props) {
  const { warrants, Name, ptsPersonID } = props.data;
  const [warrantsData, setWarrantsData] = useState([]);

  const titleName = React.useMemo(() => {
    if (Name) return Name;
    return warrantsData?.[0]?.FullName || '';
  }, [Name, warrantsData]);

  useEffect(() => {
    ptsPersonID ? getWarrantsData(ptsPersonID) : setWarrantsData(warrants);
  }, [ptsPersonID]);

  const getWarrantsData = async (ptsPersonID) => {
    const warrants = await getPersonWarrant(ptsPersonID);
    if (!warrants || !warrants.length) {
      setWarrantsData([]);
      return;
    }
    setWarrantsData(warrants);
  };

  const close = () => {
    props.closeWarrants();
  };

  return (
    <Dialog toolbar onClose={close} title={`Warrants: ${titleName}`}>
      <WarrantCard warrants={warrantsData} />
    </Dialog>
  );
}

export default connect(null, {
  closeWarrants,
  handleError,
})(WarrantDialog);
